export default __webpack_public_path__ + "static/media/day2_team.58d1ab65.jpg";